<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="ma-3 white--text"
        color="primary"
        :loading="loading"
        :disabled="employees.length <= 0"
        v-on="on"
      >
        generate
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Generate EA form"
      text="Generate EA form for the selected year and companies"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="7">
              <v-card class="pa-4 elevation-5">
                <v-data-table
                  v-model="selectedEmployees"
                  v-validate="'required'"
                  dense
                  :loading="tableLoading"
                  :headers="headers"
                  :items="filteredEmployees"
                  item-key="company_employee_uid"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-value="company_employee_uid"
                  show-select
                  class="elevation-1 mb-3 cursor-pointer"
                  height="272px"
                  :error-messages="errors.collect('selectedEmployees')"
                  data-vv-name="selectedEmployees"
                  data-vv-as="employee selection"
                >        
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar
                        flat
                        color="white"
                      >
                        <v-toolbar-title>Employee Selection:</v-toolbar-title>
                      </v-toolbar>
                    </v-row>
                  </template>
                </v-data-table>
                
                <div :class="errors.first('selectedEmployees') ? 'py-0' : 'py-3'">
                  <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
                </div>
              </v-card>
            </v-col>
            
            <v-col cols="5">
              <v-text-field
                v-model="searchInput"
                placeholder="Filter employee by name"
                append-icon="search"
                label="Search Employee"
                hide-no-data
                hide-selected
              />
              
              <v-menu
                v-model="eaFormDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="eaFormDateDisplay"
                    v-validate="'required'"
                    label="EA Form Date"
                    :error-messages="errors.collect('eaFormDateDisplay')"
                    data-vv-name="eaFormDateDisplay"  
                    data-vv-as="date"    
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="eaFormDate"
                  @input="eaFormDateMenu = false"
                />
              </v-menu>

              <v-col class="mt-2">
                <span> Merge all in one files? </span>
                <v-radio-group
                  v-model="isMerged"
                  class="mt-0"
                  row
                >
                  <v-radio
                    label="No"
                    :value="0"
                  />
                  <v-radio
                    label="Yes"
                    :value="1"
                  /> 
                </v-radio-group>
              </v-col>
              
              <v-col
                v-if="!isMerged"
                class="mt-2"
              >
                <span>Encrypt each file with password ? </span>
                <v-radio-group
                  v-model="isEncrypted"
                  class="mt-0"
                  row
                >
                  <v-radio
                    label="No"
                    :value="0"
                  />
                  <v-radio
                    label="Yes"
                    :value="1"
                  /> 
                </v-radio-group>
              </v-col>

              <v-card-actions style="position: absolute;bottom: 30px;right: 0px;">
                <v-spacer />
                <v-btn
                  :disabled="loading"
                  text
                  @click="closeDialog"
                >
                  Close
                </v-btn>              
                <v-btn
                  :loading="loading"
                  color="hrissecondary"
                  class="white--text px-10"
                  @click="submitForm"
                >
                  Generate
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employees: {
        type: Array,
        required: true,
      },
      companies: {
        type: Array,
        required: true,
      },
      selectedCompanies: {
        type: Array,
        required: true,
      },
      selectedYear: {
        type: Number,
        required: true,
      }, 
    },
    data () {
      return {
        dialog: false,
        loading: false,
        selectedEmployees: [],
        tableLoading: false,
        searchInput: '',
        isMerged: 0,
        isEncrypted: 0,
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Company',
            align: 'left',
            sortable: true,
            value: 'company_name',
          },
        ],
        eaFormDate: null,
        eaFormDateMenu: false,
      }
    },

    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })

        return primaryFilterEmployees
      },
      eaFormDateDisplay () {
        return this.eaFormDate ? this.$moment(this.eaFormDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      lastDayOfFeb () {
        return this.$moment().endOf('month').month(1).format('YYYY-MM-DD')
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
        this.$resetData()
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.payrollReports().employeeEa(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            })
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/zip' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'EA Form_' + this.selectedYear + '.zip') 
                link.click()
                this.progressbar = 0

                this.$snack({ message: 'EA Form downloaded successfully' })
              })
              .catch(error => {
                if (error.response.status === 400) {
                  this.$snack({ 
                    color: 'error',
                    message: 'Unable to generate EA', 
                  })
                }
              })
              .then(() => {
                this.loading = false
                this.closeDialog()
              })
          })
      },
      prepareFormData () {
        return {
          eaDate: this.eaFormDate,
          isMerged: this.isMerged,
          isEncrypted: this.isMerged ? 0 : this.isEncrypted,
          year: this.selectedYear,
          selectedCompanyEmployeeUids: this.selectedEmployees,
          companies: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies }
      },       
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
.cursor-pointer >>> tr{
  cursor: pointer;
}
</style>
